/** NIZ (initial extractable) = initial geological × recovery factor. */

export interface LayerResourceNizInput {
  initial_geological?: number | null;
  recovery_factor?: number | null;
}

export function computeLayerExtractable(layer: LayerResourceNizInput): number | null {
  const geo = layer.initial_geological;
  const rf = layer.recovery_factor;
  if (geo == null || rf == null || !(geo > 0) || !(rf > 0)) {
    return null;
  }
  return geo * rf;
}
